import React from 'react';

import './Bullet.scss';

const Bullet = props => {
    const BulletClass = [
        'Bullet', 
        props.score === 100 ? "Bullet--1" : 'Bullet--2',
    ];

    let bulletContent;

    if(typeof props.subNLink  === 'string' || props.subNLink.length === 1){
        bulletContent = (
            <div className="Bullet__copy">
                <div className="Bullet__copy--main">
                    {props.mainN}
                </div>
                <a href={props.subNLink} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
                    <span>{props.subNLinkText}</span>
                </a>
            </div>
        );
    }else{
        // let links = [];

        bulletContent = (
            <div className="Bullet__copy">
                <div className="Bullet__copy--main">
                    {props.mainN}
                </div>
                {props.subNLink.map((link, idx)=> (
                    <a key={`link--${idx}`} href={link} targer="_blank" rel='noreferrer' className="Bullet__copy--sub">
                        <span>{props.subNLinkText[idx]}</span>
                    </a>
                ))}
            </div>
        );

        <div className="Bullet__copy">
            <div className="Bullet__copy--main">
                {props.mainN}
            </div>
            <a href={props.subNLink} targer="_blank" rel='noreferrer' className="Bullet__copy--sub">
                <span>{props.subNLinkText}</span>
            </a>
        </div>
    }   
    //     let linkNCopy = [];

    //     props.mainN.forEach((negCopy, i)=>{
    //         linkNCopy.push(
    //             <div className="Bullet__copy--main">
    //                 {negCopy}
    //             </div>
    //         );

    //         linkNCopy.push(
    //             <a href={props.subNLink[i]} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
    //                 <span>{props.subNLinkText[i]}</span>
    //             </a>
    //         )
    //     });

    //     bulletContent = (
    //         <div className="Bullet__copy">
    //             {linkNCopy}
    //         </div>
    //     )
    // }

    // {panels.map((panel,i) => (
    //     <Panel
    //         classAdd='__question'
    //         pnlMvmtHnldr = {panelMovementHandlr}
    //         pnl={panel}
    //         pnlsLen={panels.length}
    //         key={`panel-${i}`}
    //         pnlIdx={i}
    //     />
    // ))}
    
   
    return (
        <div className={BulletClass.join(' ')}>
            <div className="Bullet__header">
                <div className="Bullet__radio Bullet__radio--1"></div>
                <div className="Bullet__title">{props.title}</div>
            </div>
            {bulletContent}
            {/* <div className="Bullet__copy">
                <div className="Bullet__copy--main">
                    {props.mainN}
                </div>
                <a href={props.subNLink} target="_blank" rel='noreferrer' className="Bullet__copy--sub">
                    <span>{props.subNLinkText}</span>
                </a>
            </div> */}
        </div>
    )
}

export default Bullet;